import { motion } from "framer-motion";
import { Mic, NotebookPen, Shirt, Users, Star, Radio } from "lucide-react";

const items = [
  { n: "01", title: "Podcast", icon: Mic, span: "md:col-span-8", desc: "The main hub for real conversations, motivational stories, guest wisdom, and practical mindset shifts." },
  { n: "02", title: "Unlock Notes", icon: NotebookPen, span: "md:col-span-4", desc: "A newsletter with episode takeaways, journal prompts, and behind-the-scenes updates." },
  { n: "03", title: "Merch Drops", icon: Shirt, span: "md:col-span-4", desc: "Intentional apparel and listener tools that make the brand visible beyond the screen." },
  { n: "04", title: "Community", icon: Users, span: "md:col-span-4", desc: "Accountability challenges, listener wins, reset weeks, and shared momentum." },
  { n: "05", title: "Guest Circle", icon: Star, span: "md:col-span-4", desc: "Featured voices, collaborations, and partner conversations that expand the mission." },
  { n: "06", title: "Live Sessions", icon: Radio, span: "md:col-span-8", desc: "Virtual workshops, pop-up talks, and in-person moments built around clarity and purpose." },
];

export default function Ecosystem() {
  return (
    <section id="ecosystem" className="relative py-24 sm:py-32 bg-charcoal/40" data-testid="ecosystem-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="mb-14 max-w-2xl">
          <p className="overline text-blaze mb-4">The full ecosystem</p>
          <h2 className="font-heading font-800 tracking-tight text-4xl sm:text-5xl leading-tight">
            More than a podcast. A home for unlocked living.
          </h2>
        </div>

        <div className="grid md:grid-cols-12 gap-5">
          {items.map((it, i) => (
            <motion.div
              key={it.n}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
              className={`${it.span} group rounded-2xl border border-white/10 bg-ink p-7 hover:border-blaze/40 transition-colors`}
              data-testid={`ecosystem-item-${it.n}`}
            >
              <div className="flex items-center justify-between">
                <span className="grid place-items-center h-11 w-11 rounded-xl bg-white/5 border border-white/10 text-blaze group-hover:bg-blaze group-hover:text-white transition-colors">
                  <it.icon size={18} />
                </span>
                <span className="font-mono text-white/25 text-sm">{it.n}</span>
              </div>
              <h3 className="mt-5 font-heading font-700 text-xl">{it.title}</h3>
              <p className="mt-2 text-sm text-white/55 leading-relaxed">{it.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
